import { useState } from "react";
import { FiX, FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const HeaderTopNews = () => {
  const [deactive, setClass] = useState("");
  return (
    <div
      className={`header-top-news bg_image ${deactive}`}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/top-banner.png)`,
      }}
    >
      <div className="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner">
                <div className="content">
               
                  <span className="rn-badge">Virtual Courses & Independent Learning</span>
                  <Link className="btn-read-more" to="/products/safepolice">
                  <span className="news-text">
                    Find out about our newest certification Safety And Police Encounters{" "}
                  </span>
                  </Link>
                </div>
                <div className="right-button">
                  <Link className="btn-read-more" to="/products/safepolice">
                    <span>
                      More Details <FiArrowRight />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="icon-close">
        <button className="close-button" onClick={() => setClass("deactive")}>
          <FiX />
        </button>
      </div>
    </div>
  );
};

export default HeaderTopNews;
